(function () {
  var SWIPER_POLL_MS = 40;
  var SWIPER_MAX_POLLS = 80;

  function waitForSwiper(root, attempt, onReady) {
    if (typeof Swiper !== 'undefined') {
      onReady();
      return;
    }
    if (attempt >= SWIPER_MAX_POLLS) return;
    root._ifCatWaitT = setTimeout(function () {
      waitForSwiper(root, attempt + 1, onReady);
    }, SWIPER_POLL_MS);
  }

  function initSwiper(root) {
    if (!root) return;
    var el = root.querySelector('.if-cat__swiper');
    if (!el) return;
    if (el.dataset.ifCatInitialized === 'true') return;

    var pagination = root.querySelector('.if-cat__pagination');
    var tabletBp = parseInt(root.getAttribute('data-if-cat-tablet'), 10);
    if (!tabletBp || tabletBp < 400) tabletBp = 750;

    function runInit() {
      if (el.dataset.ifCatInitialized === 'true') return;

      var slideCount = el.querySelectorAll('.swiper-slide').length;
      if (slideCount < 1) {
        el.dataset.ifCatInitialized = 'true';
        return;
      }

      var pagConfig = false;
      if (slideCount > 1 && pagination) {
        pagConfig = {
          el: pagination,
          clickable: true,
        };
      }

      var breakpoints = {};
      breakpoints[0] = {
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        spaceBetween: 12,
      };
      breakpoints[tabletBp] = {
        slidesPerView: 2.3,
        slidesPerGroup: 1,
        spaceBetween: 16,
      };
      breakpoints[990] = {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 16,
      };

      var swiper = new Swiper(el, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 12,
        watchOverflow: true,
        speed: 450,
        pagination: pagConfig,
        breakpoints: breakpoints,
      });

      el.dataset.ifCatInitialized = 'true';
      el._ifCatSwiper = swiper;

      function onResize() {
        if (swiper && typeof swiper.update === 'function') {
          swiper.update();
        }
      }

      root._ifCatResize = onResize;
      window.addEventListener('resize', onResize);
    }

    waitForSwiper(root, 0, runInit);
  }

  function destroyRoot(root) {
    if (!root) return;
    if (root._ifCatWaitT) {
      clearTimeout(root._ifCatWaitT);
      root._ifCatWaitT = null;
    }
    if (root._ifCatResize) {
      window.removeEventListener('resize', root._ifCatResize);
      root._ifCatResize = null;
    }
    var el = root.querySelector('.if-cat__swiper');
    if (el && el._ifCatSwiper) {
      try {
        el._ifCatSwiper.destroy(true, true);
      } catch (e) {}
      el._ifCatSwiper = null;
      el.dataset.ifCatInitialized = 'false';
    }
  }

  function scan() {
    document.querySelectorAll('[data-if-shop-by-category]').forEach(initSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (!t) return;
    var root = t.querySelector ? t.querySelector('[data-if-shop-by-category]') : null;
    if (root) initSwiper(root);
    else if (t.matches && t.matches('[data-if-shop-by-category]')) initSwiper(t);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var t = ev.target;
    if (!t) return;
    var root = t.querySelector ? t.querySelector('[data-if-shop-by-category]') : null;
    if (root) destroyRoot(root);
    else if (t.matches && t.matches('[data-if-shop-by-category]')) destroyRoot(t);
  });
})();
